import React, { Fragment, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import MEModal from '../../components/MEModal'
import { useStateValue } from '@State'
import { tempAccess } from '../actions'
import { toast } from '@CommonComponents/toast'

export const TempAccess = () => {
  const [currentState, dispatch] = useStateValue()

  const [tempAccessModalOpen, setTempAccessModalOpen] = useState(false)
  const [tempAccessEmail, setTempAccessEmail] = useState('')
  const [tempAccessFirstName, setTempAccessFirstName] = useState('')
  const [tempAccessLastName, setTempAccessLastName] = useState('')
  const [tempAccessDays, setTempAccessDays] = useState(10)
  const [emailTouched, setEmailTouched] = useState(false)

  const toggleTempAccessModal = () => {
    setTempAccessModalOpen(!tempAccessModalOpen)
    setTempAccessEmail('')
    setEmailTouched(false)
  }

  const isValidEmail = val => val.length === 0 || /\S+@\S+/.test(val)

  const handleEmailChange = e => {
    setTempAccessEmail(e.target.value)
    setEmailTouched(true)
  }

  const handleFormSubmit = async e => {
    e.preventDefault()
    setEmailTouched(true)
    if (!isValidEmail(tempAccessEmail)) return

    let data = { ...currentState.filters }
    data.email = tempAccessEmail
    data.first_name = tempAccessFirstName
    data.last_name = tempAccessLastName
    data.days = tempAccessDays
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage
    try {
      await tempAccess(data, dispatch)
      toggleTempAccessModal()
      toast.success(
        'An email has been sent to the student granting temporary access.'
      )
    } catch (err) {
      toggleTempAccessModal()
      toast.error('There was a problem granting temporary access.')
    }
  }

  const daysAccessLoop = () => {
    var options = []
    for (var days = 1; days <= 14; days++) {
      options.push(days)
    }
    return options
  }

  return (
    <Fragment>
      <Button variant="link" onClick={toggleTempAccessModal}>
        <i className="fa-light fa-fw fa-unlock-alt" /> Grant Temporary Access
      </Button>
      <MEModal
        show={tempAccessModalOpen}
        close={toggleTempAccessModal}
        title="Grant Temporary Access"
      >
        <p>
          Please enter student information below. The student will be granted
          access for 10 days.
        </p>
        <p>
          An automated email with login instructions will automatically be sent
          to the student.
        </p>
        <form>
          <Form.Group controlId="emailInput">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              value={tempAccessEmail}
              onChange={handleEmailChange}
              isInvalid={emailTouched && !isValidEmail(tempAccessEmail)}
            />
            {emailTouched && !isValidEmail(tempAccessEmail) && (
              <small className="text-danger">
                Please enter a valid email address.
              </small>
            )}
          </Form.Group>
          <Form.Group controlId="firstNameInput">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              value={tempAccessFirstName}
              onChange={e => setTempAccessFirstName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="lastNameInput">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              value={tempAccessLastName}
              onChange={e => setTempAccessLastName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="daysInput">
            <Form.Label>Days of Temporary Access Needed</Form.Label>
            <Form.Control
              as="select"
              defaultValue={tempAccessDays}
              value={tempAccessDays}
              onChange={e => setTempAccessDays(e.target.value)}
            >
              {daysAccessLoop().map((x, key) => (
                <option key={key} value={x}>
                  {x}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Button
            type="submit"
            className="btn-myed btn-primary-myed"
            variant="primary"
            disabled={!tempAccessEmail || !/\S+@\S+/.test(tempAccessEmail)}
            onClick={handleFormSubmit}
          >
            Submit
          </Button>
          <Button
            type="button"
            className="btn-myed btn-default-myed"
            variant="secondary"
            onClick={toggleTempAccessModal}
          >
            Cancel
          </Button>
        </form>
      </MEModal>
    </Fragment>
  )
}
